export default __webpack_public_path__ + "static/media/cross-icon.cd0af969.svg";